/* eslint-disable*/
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { Alert } from '@material-ui/lab';
import { ReactComponent as PhoneIcon } from '@assets/images/PhoneIcon.svg';

import {
  Grid,
  Link,
  Typography,
  Box,
  TextField,
  InputLabel,
  Button,
  Container,
  Select,
  MenuItem,
  IconButton,
  Snackbar,
  Checkbox,
  Chip,
} from '@material-ui/core';
import * as yup from 'yup';
import { InputAdornment } from '@material-ui/core';
// import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import { ReactComponent as LocationIcon } from '@assets/images/LocationIcon.svg';
import { ReactComponent as TrashIcon } from '@assets/images/TrashWhite.svg';
import { Formik, Form, Field, useFormik, FastField } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import useCommunityList from '@hooks/useCommunityList';
import PhotoCameraOutlinedIcon from '@material-ui/icons/PhotoCameraOutlined';
import ModalEditViewDelete from '../../ModalEditViewDelete/ModalEditViewDelete';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { showErrIfTouched } from '@utils';
import * as Yup from 'yup';
import { set, values } from 'lodash';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import ArrowDropDownOutlinedIcon from '@material-ui/icons/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@material-ui/icons/ArrowDropUpOutlined';
import { ReactComponent as SnackBarTrashIcon } from '@assets/images/TrashIcon.svg';
import { ReactComponent as WebsiteIcon } from '@assets/images/WebsiteIcon.svg';
import { ReactComponent as EmailIcon } from '@assets/images/EmailIcon.svg';

import { backendLocalUrl, FROM } from '@constants/globalConstants';
import useClub from '@hooks/useClub';
import { emailRegex, phoneRegex, urlRegex } from '@constants/regex';
import { validatePhoneNumber, validateWebsiteUrl } from '@utils/Helper';

const CommunityEditViewAddNewClub = (props) => {
  const theme = useTheme();
  const key = 'iFrasCwdJh';

  // Checkbox icons for Autocomplete
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  const [showAmenityDeleteBox, setShowAmenityDeleteBox] = useState(false);
  const [showDeleteBox, setShowDeleteBox] = useState(false);
  const [amenitiesDesc, setAmenitiesDesc] = React.useState('');

  const [amenityCategories, setAmenityCategories] = useState([]);
  const [amenityToEdit, setAmenityToEdit] = useState(null);
  const [isEditView, setIsEditView] = useState(false);
  const [selectedAmenityCategory, setSelectedAmenityCategory] = useState(null);
  const [initialValues, setInitialValues] = useState({
    preferredContactMethod: 'Email',
    amenityTypes: [],
  });
  const [snackBarStatus, setSnackBarStatus] = useState(false);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [contactMethods] = useState([
    { id: 1, name: 'Email' },
    { id: 2, name: 'Phone Number' },
  ]);
  const {
    addAmenitiesDescForCommunity,
    getAmenityById,
    deleteAmenity,
    toggleAmenityFeatured,
  } = useCommunityList();
  const {
    addClubDescForCommunity,
    getClubCategories,
    addClub,
    getClubById,
    toggleClubFeatured,
    deleteClub,
  } = useClub();
  const params = useParams();
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const maxImages = 6;
  const maxFileSize = 5 * 1024 * 1024;
  const imgDimensions = {
    width: 1200,
    height: 720,
    minWidth: 400,
    minHeight: 236,
    ratio: 1.3,
    errorMessage:
      'For optimal display, please ensure images have a balanced 4:3 width-to-height ratio with a minimum width of 400 pixels.',
  };
  const [uploadError, setUploadError] = useState(null);
  const [isImagesDirty, setIsImagesDirty] = useState(false);
  const formData = new FormData();
  const formikRef = React.createRef();
  let imageDim = {};
  const [isCommunityRepresentative] = useState(params?.id === loggedInUserData?.communityId);
  const [previmages, setPrevimages] = useState(images);
  const [isAccessible, setIsAccessible] = React.useState('');
  const [isTogglingFeatured, setIsTogglingFeatured] = useState(false);

  const handleClose = () => {
    setSnackBarOpen(false);
    // Only navigate back for add operations, not for toggle operations
    if (snackBarStatus?.type === 'add' && snackBarStatus?.status) {
      goBack();
    }
  };

  // Phone formatting handler - formats as (XXX) XXX-XXXX
  const handlePhoneChange = (event, setFieldValue) => {
    const inputPhoneNumber = event.target.value;
    // Remove all non-numeric characters from the input
    const cleanedPhoneNumber = inputPhoneNumber.replace(/\D/g, '');
    // Limit the phone number to 10 digits
    const truncatedPhoneNumber = cleanedPhoneNumber.slice(0, 10);
    // Format the phone number as (XXX) XXX-XXXX
    const formattedPhoneNumber = truncatedPhoneNumber.replace(
      /(\d{3})(\d{3})(\d{4})/,
      '($1) $2-$3',
    );
    // Update Formik's field value with the formatted phone number
    setFieldValue('phoneNumber', formattedPhoneNumber);
  };

  const validationSchema = Yup.object().shape(
    {
      imageList: Yup.mixed()
        .test('fileSize', 'File size too large, max file size is 5MB', (fileVal) =>
          fileVal ? fileVal.size <= maxFileSize : true,
        )
        .test('fileType', 'Incorrect file type', (fileVal) =>
          fileVal ? ['image/png', 'image/jpg', 'image/jpeg'].includes(fileVal.type) : true,
        ),

      amenityTypes: Yup.array()
        .min(1, 'At least one Club/Connection type is required')
        .required('Club/Connection type is required'),

      amenityName: Yup.string().trim().required('Club/Connection name is required'),

      amenityDesc: Yup.string().trim().required('Club/Connection description is required'),

      preferredContactMethod: Yup.string().required('Preferred contact method is required'),

      phoneNumber: Yup.string().when('preferredContactMethod', {
        is: (preferredContactMethod) => preferredContactMethod === 'Phone Number',
        then: (schema) =>
          schema
            .required('Phone number is required')
            .matches(phoneRegex, 'Not a valid phone number'),
        otherwise: (schema) => schema.nullable().matches(phoneRegex, 'Not a valid phone number'),
      }),

      email: Yup.string().when('preferredContactMethod', {
        is: (preferredContactMethod) => preferredContactMethod === 'Email',
        then: (schema) =>
          schema
            .required('Email is required')
            .matches(
              emailRegex,
              'Improper format: Please enter using the correct format (eg. name@email.com)',
            ),
        otherwise: (schema) =>
          schema
            .nullable()
            .matches(
              emailRegex,
              'Improper format: Please enter using the correct format (eg. name@email.com)',
            ),
      }),

      website: Yup.string().nullable().matches(urlRegex, 'Website must be in a valid format.'),
    },
    [
      ['phoneNumber', 'preferredContactMethod'],
      ['email', 'preferredContactMethod'],
    ],
  );
  const handleTextAreaChange = (event, value) => {
    setAmenitiesDesc(value);
  };

  // Helper function to check if there are changes other than the featured status
  const checkForOtherChanges = (currentValues, initialValues) => {
    // Create copies of the values excluding the featuredAmenity field
    const currentValuesWithoutFeatured = { ...currentValues };
    const initialValuesWithoutFeatured = { ...initialValues };

    // Remove featuredAmenity from comparison since we're specifically toggling it
    delete currentValuesWithoutFeatured.featuredAmenity;
    delete initialValuesWithoutFeatured.featuredAmenity;

    // Compare all other fields
    return (
      JSON.stringify(currentValuesWithoutFeatured) !== JSON.stringify(initialValuesWithoutFeatured)
    );
  };

  const reset = (values, images) => {
    values = {};
    setImages([]);
  };

  const handleBackToParent = (e, formikObj) => {
    e.preventDefault();
    // if (!(!formikObj.dirty || !formikObj.isValid || formikObj.isSubmitting) || isImagesDirty) {
    if (
      !(!formikObj.dirty || formikObj.isSubmitting) ||
      isImagesDirty ||
      images.length !== previmages.length
    ) {
      setShowDeleteBox(true);
    } else {
      goBack();
    }
  };

  const onTakeMeback = (event) => {
    //console.log('here');
    setShowDeleteBox(false);
    setShowAmenityDeleteBox(false);
  };

  const goBackUrl = () => {
    //console.log('here');
    if (params?.from === FROM.CLUBS_LIST) {
      return `../../../../club-community-all/${params?.id}`;
    } else {
      return `../../../../community-details/${params?.id}#Section12`;
    }
  };
  const goBack = () => {
    navigate(goBackUrl());
  };

  const handleDeleteAmenity = async (response) => {
    if (response) {
      setShowDeleteBox(false);
      const result = await deleteClub({ id: params?.amenityId });
      if (result) {
        reset(values, images);
        setSnackBarStatus({ status: result?.status, message: result?.message, type: 'delete' });
        setSnackBarOpen(true);
        setTimeout(() => {
          setSnackBarOpen(false);
          goBack();
        }, 2500);
      }
    }
  };

  const handleToggleFeatured = async (setFieldValue, currentValue, formikBag) => {
    if (!params?.amenityId || params?.amenityId === 'default') {
      // For new amenities, just toggle the form value
      const newValue = !currentValue;
      setFieldValue('featuredAmenity', newValue);
      return;
    }

    setIsTogglingFeatured(true);
    try {
      const newValue = !currentValue;

      // Check if there are other changes besides the featured status
      const hasOtherChanges = checkForOtherChanges(formikBag.values, formikBag.initialValues);

      const result = await toggleClubFeatured({
        clubId: params?.amenityId,
        featuredClub: newValue,
      });

      if (result?.status) {
        setFieldValue('featuredAmenity', newValue);

        // If only the featured status changed and no other form changes or image changes exist, reset dirty state
        if (!hasOtherChanges && !isImagesDirty && images.length === previmages.length) {
          // Reset the form to make it clean, but keep the current values
          formikBag.resetForm({
            values: {
              ...formikBag.values,
              featuredAmenity: newValue,
            },
          });
        }

        setSnackBarStatus({
          status: true,
          message: result?.message,
          type: 'toggle',
        });
        setSnackBarOpen(true);
        /* setTimeout(() => {
          setSnackBarOpen(false);
          goBack();
        }, 2500); */
      } else {
        setSnackBarStatus({
          status: false,
          message: result?.message || 'Failed to update featured status',
          type: 'toggle',
        });
        setSnackBarOpen(true);
      }
    } catch (error) {
      setSnackBarStatus({
        status: false,
        message: 'An error occurred while updating featured status',
        type: 'toggle',
      });
      setSnackBarOpen(true);
    } finally {
      setIsTogglingFeatured(false);
    }
  };

  const handlePublish = async (values) => {
    //loggedIn user sholuld be community rep and param should have community Id

    try {
      const clubDesc = values?.amenityDesc?.trim();
      const clubName = values?.amenityName?.trim();
      formData.append('communityId', params?.id);
      formData.append('repId', loggedInUserData?.id);
      formData.append('isAdminEntry', Boolean(loggedInUserData?.roleId === 2));
      formData.append('clubCategoryId', values?.amenityCategory);
      formData.append('clubDesc', clubDesc);
      formData.append('clubName', clubName);

      // Send multiple club type IDs
      if (values?.amenityTypes && values.amenityTypes.length > 0) {
        formData.append('clubTypeIds', JSON.stringify(values.amenityTypes));
        formData.append('clubTypeId', values.amenityTypes[0]); // First type for backward compatibility
      }

      formData.append('clubAddress', values?.address || '');
      formData.append('featuredClub', values?.featuredAmenity || false);
      formData.append('phoneNumber', values?.phoneNumber || '');
      formData.append('email', values?.email || '');
      formData.append('website', values?.website || '');
      formData.append('preferredContactMethod', values?.preferredContactMethod || '');
      params?.amenityId &&
        params?.amenityId !== 'default' &&
        formData.append('clubId', params?.amenityId);
      images.forEach((file, index) => {
        formData.append(`imageList`, file);
      });
      // formData.append('imageList', images);
      const result = await addClub(formData);
      // console.log(result, 3131);
      if (result) {
        setSnackBarStatus({ status: result?.status, message: result?.message, type: 'add' });
        setSnackBarOpen(true);
        reset(values, images);
      }
    } catch (e) {}
  };

  const isSupportedFileType = (file) => {
    const acceptedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    return acceptedTypes.includes(file.type);
  };

  const getUniqueIdentifier = (file) => {
    //console.log('getUniqueIdentifier');
    return `${file.size}`;
  };

  const loadImageAndCheckDimensions = (src, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const width = img.width;
        const height = img.height;
        //console.log(parseFloat((width / height)?.toFixed(2)), '1919');
        if (
          !(width >= imgDimensions?.minWidth) &&
          parseFloat((width / height)?.toFixed(1)) !== imgDimensions?.ratio
        ) {
          resolve('Incorrect Photo dimensions');
        } else {
          resolve('Photo dimensions are within the allowed limits.');
        }
        // if (Number(width) !== Number(maxWidth) || Number(height) !== Number(maxHeight)) {
        //   resolve('Incorrect Photo dimensions');
        // } else {

        // }
      };

      img.onerror = (event) => {
        const error = new Error('Image failed to load');
        error.event = event; // attach original event if needed
        reject(error);
      };

      img.src = src;
    });
  };

  const handleImageUpload = async (event, values, errors, form, field) => {
    //console.log(event, 1111);
    if (event) {
      const selectedFiles = event.target.files;
      let checkImageDims = '';
      let newImages = [];

      for (const file of selectedFiles) {
        if (!isSupportedFileType(file)) {
          setUploadError('Incorrect file type');
          return;
        }

        if (file.size > maxFileSize) {
          setUploadError('File size too large, max file size is 5mb');
          return;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(file);

          try {
            const imageSrc = await new Promise((resolve, reject) => {
              reader.onload = () => {
                resolve(reader.result);
              };
              reader.onerror = (event) => {
                const error = new Error('Image failed to load');
                error.event = event; // attach original event if needed
                reject(error);
              };
            });

            checkImageDims = await loadImageAndCheckDimensions(
              imageSrc,
              imgDimensions.width,
              imgDimensions.height,
            );
          } catch (error) {}
        }
        // imgDimensions
        newImages = Array.from(selectedFiles).filter(
          (file) =>
            isSupportedFileType(file) &&
            file.size <= maxFileSize &&
            !images.some((image) => {
              //console.log(getUniqueIdentifier(image), '===', getUniqueIdentifier(file));
              return getUniqueIdentifier(image) === getUniqueIdentifier(file);
            }),
        );
        //console.log(newImages, 6565);
        if (newImages.length == 0) {
          setUploadError('Duplicate image is not allowed');
          return;
        }
        newImages = Array.from(selectedFiles);
        if (newImages.length + images.length > maxImages) {
          alert(`You can only select up to ${maxImages} images.`);
          return;
        }
        if (checkImageDims == 'Incorrect Photo dimensions') {
          setUploadError(imgDimensions?.errorMessage);
          return;
        }
      }

      setUploadError(null);

      const imageList = [...images, ...newImages];
      setImages(imageList);
      //console.log(imageList, 1111);
      // setPrevimages(imageList);
    }
  };

  const handleImageDelete = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    //console.log(newImages, 8686);
    setImages(newImages);
    // setPrevimages(newImages);
  };

  const loadAmenityCategories = async () => {
    const amenityCatArr = await getClubCategories();
    setAmenityCategories(amenityCatArr.usersResult);
  };
  const loadAmenity = async () => {
    try {
      if (params?.amenityId && params?.amenityId !== 'default') {
        //load club details from master
        const clubArr = await getClubById({ id: params?.amenityId });
        setAmenityToEdit(clubArr.usersResult);
        if (clubArr.usersResult) {
          setIsEditView(true);
          //load club types
          const selectedAmenityCat = amenityCategories.find(
            (category) => category?.id == clubArr.usersResult[0]?.clubCategory?.id,
          );
          setSelectedAmenityCategory(selectedAmenityCat);

          //load images
          await fetchServerImages(clubArr.usersResult[0]?.clubGallery);

          //set initial values
          // Handle both clubTypes array (new format) and single clubType (old format)
          const clubData = clubArr.usersResult[0];
          const clubTypeIds =
            clubData?.clubTypes && Array.isArray(clubData.clubTypes)
              ? clubData.clubTypes.map((type) => type.id)
              : clubData?.clubType?.id
              ? [clubData.clubType.id]
              : [];

          setInitialValues({
            amenityDesc: (clubArr.usersResult && clubArr.usersResult[0]?.clubDesc) || '',
            amenityTypes: clubTypeIds,
            amenityTypeName:
              (clubArr.usersResult && clubArr.usersResult[0]?.clubType?.clubTypeName) || '',
            amenityCategory:
              (clubArr.usersResult && clubArr.usersResult[0]?.clubCategory?.id) || '',
            amenityCategoryName:
              (clubArr.usersResult && clubArr.usersResult[0]?.clubCategory?.clubCategoryName) || '',
            amenityName: (clubArr.usersResult && clubArr.usersResult[0]?.clubName) || '',
            address: (clubArr.usersResult && clubArr.usersResult[0]?.clubAddress) || '',
            featuredAmenity: clubArr.usersResult[0]?.featuredClub || false,
            phoneNumber: (clubArr.usersResult && clubArr.usersResult[0]?.clubPhone) || '',
            email: (clubArr.usersResult && clubArr.usersResult[0]?.clubEmail) || '',
            website: (clubArr.usersResult && clubArr.usersResult[0]?.clubWebsite) || '',
            preferredContactMethod:
              (clubArr.usersResult && clubArr.usersResult[0]?.preferredContactMethod) || 'Email',
            //images: clubArr.usersResult[0]?.clubGallery || [],
          });
        } else {
          setIsEditView(false);
        }
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const fetchServerImages = async (storedImagesArray) => {
    try {
      const fetchedImages = await Promise.all(
        storedImagesArray.map(async (storedImage, index) => {
          const imagePath =
            window.location.hostname === 'localhost'
              ? `${backendLocalUrl.replace(/\/$/, '')}/${storedImage.image.replace(/^\//, '')}`
              : `api/${storedImage.image.replace(/^\//, '')}`;

          const response = await fetch(imagePath);

          const imageBlob = await response.blob();

          const imageUrl = URL.createObjectURL(imageBlob);

          const imageName = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);
          const imageType = imageBlob.type;
          const lastModified = Date.now();

          const imageFile = new File([imageBlob], imageName, {
            type: imageType,
            lastModified: lastModified,
          });

          return imageFile;
        }),
      );

      setImages(fetchedImages);
      setPrevimages(fetchedImages);
    } catch (error) {}
  };
  useEffect(() => {}, [images]);

  useEffect(() => {
    loadAmenityCategories();
  }, []);
  useEffect(() => {
    handleImageUpload();
  }, [uploadError]);

  useEffect(() => {}, [snackBarOpen]);

  useEffect(() => {
    //console.log(images.length, 'images');
    //console.log(previmages.length, 'previmages');
    if (
      previmages.length > 0 &&
      images.length !== previmages.length
      // ||
      // (images.length > 0 && images.length !== previmages.length)
    ) {
      setIsImagesDirty(true);
      return;
    }

    // if (images.length > 0 && images.length !== previmages.length) {
    //   setIsImagesDirty(true);
    //   return;
    // }

    for (let i = 0; i < images.length; i++) {
      if (
        previmages.length > 0 &&
        images[i]?.name !== previmages[i].name &&
        images[i]?.size !== previmages[i].size
      ) {
        //console.log(images[i], '!==', previmages[i]);
        setIsImagesDirty(true);
        return;
      }
    }
    setIsImagesDirty(false);
  }, [images]);

  useEffect(() => {
    loadAmenity();
  }, [params?.amenityId, amenityCategories]);

  useEffect(() => {
    loggedInUserData?.roleId === 1 || loggedInUserData?.roleId === 2
      ? setIsAccessible(true)
      : setIsAccessible(false);
  }, [loggedInUserData]);

  return (
    <Container>
      <Grid container className="PageSpacing FixedID">
        <Grid item xs={12}>
          {/* {loggedInUserData?.roleId == 1 && isCommunityRepresentative ? ( */}
          {isAccessible ? (
            <>
              <Grid item xs={12}>
                <Link
                  underline="none"
                  onClick={(e) => {
                    handleBackToParent(e, formikRef.current);
                  }}
                  className="BackButtonWrapper"
                >
                  <Typography className="BackButton BackButtonMb" variant="body1">
                    <ArrowBackIcon color="primary" className="BackButtonArrow" />
                    {params?.amenityId && params?.amenityId !== 'default'
                      ? 'Feature selected '
                      : 'Create your own '}
                    Club/Connection
                  </Typography>
                </Link>
              </Grid>
              <Grid container /* className="FixedID" */>
                <Grid item xs={12}>
                  <Typography variant="caption" className="SubtitleCEV AmenitiesCEV">
                    Club/connections are listed on the Community page and can be reordered. Fields
                    that are not required are marked as “Optional”
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handlePublish}
                    innerRef={formikRef}
                    enableReinitialize={true}
                  >
                    {(formikBag) => {
                      const {
                        handleSubmit,
                        setFieldValue,
                        isValid,
                        isSubmitting,
                        dirty,
                        touched,
                        handleChange,
                        values,
                        errors,
                      } = formikBag;
                      return (
                        <Form className="" onSubmit={handleSubmit} encType="multipart/form-data">
                          <Grid container className="AddAmenityForm">
                            <Grid item xs={12} className="commonFieldBox">
                              <InputLabel className="InputLabelFld" htmlFor="amenityName">
                                Club/Connection Name
                                {/* <Box
                                mb={1}
                                component="span"
                                display="inline-block"
                                className="Asterisk"
                              >
                                *
                              </Box> */}
                              </InputLabel>
                              <FastField
                                as={TextField}
                                name="amenityName"
                                id="outlined-basic"
                                variant="outlined"
                                type="text"
                                error={!!showErrIfTouched('amenityName', errors, touched)}
                                helperText={showErrIfTouched('amenityName', errors, touched)}
                                fullWidth
                                onChange={(e) => {
                                  const value = e.target.value.replace(/^\s+/, '');
                                  setFieldValue('amenityName', value);
                                }}
                              />
                            </Grid>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6} className="commonFieldBox">
                                <InputLabel className="InputLabelFld" htmlFor="amenityCategory">
                                  Category
                                </InputLabel>
                                <Autocomplete
                                  className="CommonAutocomplete"
                                  id="amenityCategory"
                                  options={amenityCategories || []}
                                  disableClearable={!selectedAmenityCategory ? true : false}
                                  value={
                                    values?.amenityCategory !== undefined &&
                                    amenityCategories.find((v) => v?.id == values?.amenityCategory)
                                  }
                                  getOptionLabel={(option) => option.clubCategoryName || ''}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder=""
                                      label=""
                                      variant="outlined"
                                    />
                                  )}
                                  onChange={(e, value) => {
                                    setFieldValue('amenityCategory', value?.id || '');
                                    setFieldValue(
                                      'amenityCategoryName',
                                      value?.clubCategoryName || '',
                                    );
                                    setFieldValue('amenityTypes', []);

                                    setSelectedAmenityCategory(value);
                                  }}
                                  popupIcon={<KeyboardArrowDownIcon />}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} className="commonFieldBox">
                                <Box display="flex" justifyContent="space-between">
                                  <InputLabel className="InputLabelFld" htmlFor="amenityTypes">
                                    Type
                                  </InputLabel>
                                  <Typography variant="caption" component="div">
                                    Requires a Category to be selected
                                  </Typography>
                                </Box>
                                <Autocomplete
                                  limitTags={1}
                                  className="CommonAutocomplete MultiSelect"
                                  id="amenityTypes"
                                  multiple={true}
                                  disableCloseOnSelect
                                  disabled={!selectedAmenityCategory}
                                  options={selectedAmenityCategory?.clubType || []}
                                  getOptionLabel={(option) => option.clubTypeName || ''}
                                  value={(() => {
                                    const selectedOptions = (
                                      selectedAmenityCategory?.clubType || []
                                    ).filter((option) =>
                                      (values.amenityTypes || []).includes(option.id),
                                    );
                                    return selectedOptions;
                                  })()}
                                  onChange={(_, newValue) => {
                                    const selectedIds = newValue.map((item) => item.id);
                                    setFieldValue('amenityTypes', selectedIds);
                                  }}
                                  renderOption={(option, { selected }) => (
                                    <li>
                                      <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        checked={selected}
                                        className="AutocompleteCheckbox"
                                      />
                                      {option.clubTypeName}
                                    </li>
                                  )}
                                  renderTags={(value, getTagProps) => {
                                    const displayedTags = value.slice(0, 1);
                                    const hiddenTagsCount = value.length - displayedTags.length;

                                    return (
                                      <>
                                        {displayedTags.map((option, index) => (
                                          <Chip
                                            key={index}
                                            label={option.clubTypeName}
                                            {...getTagProps({ index })}
                                          />
                                        ))}
                                        {hiddenTagsCount > 0 && (
                                          <Box className="TagsCounter">{`+${hiddenTagsCount}`}</Box>
                                        )}
                                      </>
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder=""
                                      label=""
                                      variant="outlined"
                                    />
                                  )}
                                  popupIcon={<KeyboardArrowDownIcon />}
                                />
                              </Grid>
                            </Grid>

                            <Grid item xs={12} className="commonFieldBox">
                              <InputLabel className="InputLabelFld" htmlFor="description">
                                Description
                              </InputLabel>
                              <Box mb={1}>
                                <Typography variant="caption" component="div">
                                  Briefly describe your group and include your usual meeting days or
                                  times.
                                </Typography>
                              </Box>
                              <Field
                                as={TextField}
                                name="amenityDesc"
                                value={values.amenityDesc}
                                className="TextFieldTextarea"
                                fullWidth
                                multiline
                                minRows={8}
                                maxRows={20}
                                label=""
                                variant="outlined"
                                onChange={(e, value) => {
                                  //console.log(e.target.value, 500);
                                  setFieldValue('amenityDesc', e.target.value);
                                  handleTextAreaChange(e, e.target.value);
                                }}
                              />
                              {touched.amenityDesc && errors.amenityDesc && (
                                <Typography color="error">{errors.amenityDesc}</Typography>
                              )}
                            </Grid>
                            <Grid item xs={12} className="commonFieldBox">
                              <Field name="imageList">
                                {({ field, form }) => (
                                  <Box className="AmenityImagesContainer">
                                    <Box display="flex" justifyContent="space-between">
                                      <InputLabel className="InputLabelFld" htmlFor="amenityImages">
                                        Images
                                      </InputLabel>
                                      <Typography variant="body2" component="div">
                                        {images.length}/{maxImages} Images
                                      </Typography>
                                    </Box>
                                    <Typography variant="body2">
                                      At least one image is required.
                                    </Typography>
                                    <Box className="AmenityImagesContent">
                                      {images.map((image, index) => (
                                        <Box key={index} elevation={3} className="AmenityImagesBox">
                                          <img
                                            src={URL.createObjectURL(image)}
                                            alt={`Image-${index + 1}`}
                                            style={{
                                              maxWidth: '100%',
                                              maxHeight: '100%',
                                            }}
                                            className="AmenityImg"
                                          />
                                          <IconButton
                                            onClick={() => handleImageDelete(index)}
                                            style={{
                                              position: 'absolute',
                                              top: 0,
                                              right: 0,
                                            }}
                                            className="AmenityImagesDeleteBox"
                                          >
                                            <TrashIcon />
                                          </IconButton>
                                        </Box>
                                      ))}

                                      {images.length < maxImages && (
                                        <label
                                          htmlFor="image-input"
                                          className="AmenityImagesUploadBox"
                                        >
                                          <input
                                            type="file"
                                            id="image-input"
                                            accept=".jpg, .jpeg, .png"
                                            style={{ display: 'none' }}
                                            multiple
                                            // onClick={(e) => {
                                            //   e.target.value = null;
                                            // }}
                                            onChange={(e) => {
                                              handleImageUpload(e, values, errors, form, field);
                                            }}
                                          />
                                          {images.length === 0 ? (
                                            <Box elevation={3} className="AmenityAddImagesBox">
                                              <PhotoCameraOutlinedIcon
                                                color="primary"
                                                fontSize="large"
                                              />
                                              <Typography
                                                variant="body2"
                                                color="primary"
                                                component="div"
                                                className="AmenityAddImagesLabel"
                                              >
                                                Add Image
                                              </Typography>
                                            </Box>
                                          ) : (
                                            <Box
                                              elevation={3}
                                              className="AmenityAddImagesBoxSecond"
                                            >
                                              <PhotoCameraIcon color="primary" fontSize="large" />
                                              <Typography
                                                variant="body2"
                                                color="primary"
                                                component="div"
                                                className="AmenityAddImagesLabel"
                                              >
                                                Add Photo
                                              </Typography>
                                            </Box>
                                          )}
                                        </label>
                                      )}
                                    </Box>
                                    {uploadError && (
                                      <Box mt={2}>
                                        {' '}
                                        <Typography
                                          variant="body2"
                                          component="div"
                                          className="CustomError"
                                        >
                                          {uploadError}
                                        </Typography>{' '}
                                      </Box>
                                    )}
                                  </Box>
                                )}
                              </Field>
                            </Grid>

                            <Grid item xs={12} className="commonFieldBox">
                              <Box display="flex" justifyContent="space-between">
                                <InputLabel
                                  className="InputLabelFld"
                                  htmlFor="preferredContactMethod"
                                >
                                  Preferred Contact Method
                                </InputLabel>
                                <Typography variant="caption" component="div">
                                  The selected option will become a required field
                                </Typography>
                              </Box>
                              <Autocomplete
                                className="CommonAutocomplete"
                                id="preferredContactMethod"
                                options={contactMethods || []}
                                disableClearable={true}
                                value={
                                  contactMethods.find(
                                    (v) => v?.name === values?.preferredContactMethod,
                                  ) ||
                                  contactMethods.find((v) => v?.name === 'Email') ||
                                  null
                                }
                                getOptionLabel={(option) => option?.name || ''}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder=""
                                    label=""
                                    variant="outlined"
                                  />
                                )}
                                onChange={(e, value) => {
                                  setFieldValue('preferredContactMethod', value?.name || 'Email');
                                }}
                                popupIcon={<KeyboardArrowDownIcon />}
                              />
                            </Grid>
                            <Grid item xs={12} className="commonFieldBox">
                              <InputLabel className="InputLabelFld" htmlFor="email">
                                Email
                                {values?.preferredContactMethod !== 'Email' && (
                                  <span style={{ marginLeft: '4px' }}>(Optional)</span>
                                )}
                              </InputLabel>
                              <FastField
                                as={TextField}
                                name="email"
                                id="outlined-basic"
                                variant="outlined"
                                type="email"
                                error={!!showErrIfTouched('email', errors, touched)}
                                helperText={showErrIfTouched('email', errors, touched)}
                                fullWidth
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <EmailIcon className="AmenityIcons" />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} className="commonFieldBox">
                              <InputLabel className="InputLabelFld" htmlFor="phoneNumber">
                                Phone Number
                                {values?.preferredContactMethod !== 'Phone Number' && (
                                  <span style={{ marginLeft: '4px' }}>(Optional)</span>
                                )}
                              </InputLabel>
                              <FastField
                                as={TextField}
                                name="phoneNumber"
                                id="outlined-basic"
                                variant="outlined"
                                type="tel"
                                error={!!showErrIfTouched('phoneNumber', errors, touched)}
                                helperText={showErrIfTouched('phoneNumber', errors, touched)}
                                fullWidth
                                onChange={(e) => handlePhoneChange(e, setFieldValue)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <PhoneIcon className="AmenityIcons" />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} className="commonFieldBox">
                              <InputLabel className="InputLabelFld" htmlFor="address">
                                Address (Optional)
                              </InputLabel>
                              <FastField
                                as={TextField}
                                name="address"
                                id="outlined-basic"
                                variant="outlined"
                                type="text"
                                fullWidth
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <LocationIcon className="AmenityIcons" />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} className="commonFieldBox">
                              <InputLabel className="InputLabelFld" htmlFor="website">
                                Website
                                {values?.preferredContactMethod !== 'Website' &&
                                  values?.preferredContactMethod !== 'Social Media' && (
                                    <span style={{ marginLeft: '4px' }}>(Optional)</span>
                                  )}
                              </InputLabel>
                              <FastField
                                as={TextField}
                                name="website"
                                id="outlined-basic"
                                variant="outlined"
                                //type="url"
                                error={!!showErrIfTouched('website', errors, touched)}
                                helperText={showErrIfTouched('website', errors, touched)}
                                fullWidth
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <WebsiteIcon className="FacilityIcons" />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <Box className="Wrapper">
                                <Button
                                  disabled={
                                    !values.amenityName ||
                                    !values.amenityDesc ||
                                    !values.amenityCategory ||
                                    !values.amenityCategoryName ||
                                    !values.amenityTypes ||
                                    values.amenityTypes.length === 0 ||
                                    !values.preferredContactMethod ||
                                    (values.preferredContactMethod === 'Email' && !values.email) ||
                                    (values.preferredContactMethod === 'Phone Number' &&
                                      !values.phoneNumber) ||
                                    images.length === 0 ||
                                    isSubmitting ||
                                    (!dirty &&
                                      !isImagesDirty &&
                                      images.length === previmages.length)
                                  }
                                  variant="contained"
                                  color="primary"
                                  type="submit"
                                  // className="EditViewButton"
                                  fullWidth
                                >
                                  {isEditView ? 'Save' : 'Feature'}
                                </Button>
                              </Box>
                            </Grid>
                            {isEditView && (
                              <Grid item xs={12}>
                                <Box className="Wrapper" mt={2}>
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    type="button"
                                    fullWidth
                                    disabled={isTogglingFeatured}
                                    onClick={() =>
                                      handleToggleFeatured(
                                        setFieldValue,
                                        values?.featuredAmenity,
                                        formikBag,
                                      )
                                    }
                                  >
                                    {isTogglingFeatured
                                      ? 'Updating...'
                                      : values?.featuredAmenity
                                      ? 'Remove From Featured'
                                      : 'Feature'}
                                  </Button>
                                </Box>
                              </Grid>
                            )}
                          </Grid>
                          <Box
                            component="div"
                            display="flex"
                            justifyContent="center"
                            mt={0.5}
                            mb={4}
                          >
                            {isEditView && (
                              <Button
                                onClick={() => {
                                  setShowAmenityDeleteBox(true);
                                }}
                                underline="none"
                                className="DeleteAmenityButton LinkTypeButton RedLineButton"
                                color="secondary"
                                variant="text"
                              >
                                Delete Club/Connection
                              </Button>
                            )}
                          </Box>
                        </Form>
                      );
                    }}
                  </Formik>
                </Grid>
              </Grid>

              {/* {console.log(showDeleteBox, 5689)} */}
              {showDeleteBox && (
                <>
                  <ModalEditViewDelete
                    status={true}
                    navigateUrl={goBackUrl()}
                    onDelete={goBack}
                    onClose={onTakeMeback}
                  ></ModalEditViewDelete>
                </>
              )}
              {showAmenityDeleteBox && (
                <>
                  <ModalEditViewDelete
                    status={true}
                    variant="amenity"
                    title="Delete this club/connection?"
                    description="You will not be able to recover it."
                    navigateUrl={goBackUrl()}
                    onClose={onTakeMeback}
                    onDelete={handleDeleteAmenity}
                  ></ModalEditViewDelete>
                </>
              )}
              <Choose>
                <When condition={!snackBarStatus?.status && snackBarStatus?.type == 'add'}>
                  <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
                    <Alert
                      elevation={6}
                      variant="filled"
                      onClose={handleClose}
                      severity="error"
                      icon={<WarningRoundedIcon color="secondary" fontSize="inherit" />}
                      action={
                        <Link
                          color="primary"
                          underline="none"
                          aria-label="close"
                          onClick={handleClose}
                          className="AlertDismissButton"
                        >
                          Dismiss
                        </Link>
                      }
                    >
                      {snackBarStatus?.message}
                    </Alert>
                  </Snackbar>
                </When>
                <When condition={snackBarStatus?.status && snackBarStatus?.type == 'delete'}>
                  <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
                    <Alert
                      elevation={6}
                      variant="filled"
                      onClose={handleClose}
                      severity="success"
                      icon={<SnackBarTrashIcon color="primary" fontSize="inherit" />}
                      action={
                        <Link
                          color="primary"
                          underline="none"
                          aria-label="close"
                          onClick={handleClose}
                          className="AlertDismissButton"
                        >
                          Dismiss
                        </Link>
                      }
                    >
                      {snackBarStatus?.message}
                    </Alert>
                  </Snackbar>
                </When>
                <When condition={snackBarStatus?.status && snackBarStatus?.type == 'add'}>
                  <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
                    <Alert
                      elevation={6}
                      variant="filled"
                      onClose={handleClose}
                      severity="success"
                      icon={<CheckCircleIcon color="primary" fontSize="inherit" />}
                      action={
                        <Link
                          color="primary"
                          underline="none"
                          aria-label="close"
                          onClick={handleClose}
                          className="AlertDismissButton"
                        >
                          Dismiss
                        </Link>
                      }
                    >
                      {snackBarStatus?.message}
                    </Alert>
                  </Snackbar>
                </When>
                <When condition={snackBarStatus?.status && snackBarStatus?.type == 'toggle'}>
                  <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
                    <Alert
                      elevation={6}
                      variant="filled"
                      onClose={handleClose}
                      severity="success"
                      icon={<CheckCircleIcon color="primary" fontSize="inherit" />}
                      action={
                        <Link
                          color="primary"
                          underline="none"
                          aria-label="close"
                          onClick={handleClose}
                          className="AlertDismissButton"
                        >
                          Dismiss
                        </Link>
                      }
                    >
                      {snackBarStatus?.message}
                    </Alert>
                  </Snackbar>
                </When>
                <When condition={!snackBarStatus?.status && snackBarStatus?.type == 'toggle'}>
                  <Snackbar open={snackBarOpen} autoHideDuration={3000} onClose={handleClose}>
                    <Alert
                      elevation={6}
                      variant="filled"
                      onClose={handleClose}
                      severity="error"
                      icon={<WarningRoundedIcon color="secondary" fontSize="inherit" />}
                      action={
                        <Link
                          color="primary"
                          underline="none"
                          aria-label="close"
                          onClick={handleClose}
                          className="AlertDismissButton"
                        >
                          Dismiss
                        </Link>
                      }
                    >
                      {snackBarStatus?.message}
                    </Alert>
                  </Snackbar>
                </When>
              </Choose>
            </>
          ) : (
            'You do not have permissions to access this url.'
          )}
        </Grid>
      </Grid>
    </Container>
  );
};
CommunityEditViewAddNewClub.defaultProps = {};
export default CommunityEditViewAddNewClub;
